module.exports = __webpack_public_path__ + "static/media/Processed Product Marketplace - GBR network - 27-05-2025 C.0a56d451.gif";